import React from "react";
import styles from "./NumberIndicator.module.scss";
import cx from "classnames";

export interface NumberIndicatorProps
  extends React.ComponentPropsWithoutRef<"div"> {
  currentIndex: number;
  numberOfImages: number;
}

export const NumberIndicator = ({
  currentIndex,
  numberOfImages,
  className,
  ...props
}: NumberIndicatorProps) => (
  <div
    className={cx(styles.counter, className)}
    data-testid="standard:gallery:number-indicator"
    {...props}
  >
    {currentIndex + 1}/{numberOfImages}
  </div>
);
